import { HELP_BASE_URL } from "./helpTopics";

const isLocalDocsDevServer = () =>
  process.env.NODE_ENV === "development" && HELP_BASE_URL.startsWith("http://localhost:3002/help");

export async function ensureHelpSession(getToken: () => Promise<string>) {
  if (isLocalDocsDevServer()) return;

  const token = await getToken();
  const response = await fetch("/auth/help-session", {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    credentials: "include",
  });

  if (!response.ok) {
    throw new Error("Unable to open help. Please refresh LandAgility and try again.");
  }
}

export async function clearHelpSession() {
  try {
    await fetch("/auth/help-session", {
      method: "DELETE",
      credentials: "include",
    });
  } catch {
    // Sign-out must continue even if the help cookie is already absent.
  }
}
